/**
 * @module router/guards/mobileRedirect
 * @description 모바일 도메인 리다이렉트 라우터 가드 — 호스트가 'M.'으로 시작하는 경우
 * PC 라우트를 자동으로 '/mobile/*' 경로로 리다이렉트합니다.
 * 대응 모바일 라우트가 없으면 리다이렉트하지 않고 원경로를 통과시켜
 * 반응형 단일 페이지가 처리하도록 합니다 (SURINP-302 — NotFound 추락 방지).
 */

/**
 * 모바일 도메인(m.*)에서 PC 경로로 접근 시 모바일 경로로 리다이렉트합니다.
 * '/mobile<path>' 가 실제 라우트로 해석될 때만 리다이렉트하며,
 * 미대응 경로(예: /repair-receipt)는 원경로 그대로 통과합니다.
 *
 * @param {import('vue-router').RouteLocationNormalized} to - 이동할 라우트
 * @param {import('vue-router').RouteLocationNormalized} from - 현재 라우트
 * @param {import('vue-router').NavigationGuardNext} next - 다음 라우트 진행 함수
 * @param {import('vue-router').Router} router - 라우트 해석에 사용할 라우터 인스턴스
 * @returns {boolean} 리다이렉트가 발생한 경우 true, 통과한 경우 false
 */
export const mobileRedirectGuard = (to, from, next, router) => {
  if (window.location.host.startsWith('m.') && !to.path.startsWith('/mobile')) {
    const mobilePath = `/mobile${to.path}`
    if (router && router.resolve(mobilePath).name !== 'NotFound') {
      next({ path: mobilePath, query: to.query, params: to.params })
      return true
    }
  }
  return false
}
